module.exports = __webpack_public_path__ + "img/public/SiteIcons/listArrowLeft.svg?9631d990";